const PAYMENT_STATUSES = {
    NEW: 'new',
    SUCCESS: 'successful',
    FAILED: 'failed',
    PENDING: 'pending',
    WAITING: 'waiting',
};

export default PAYMENT_STATUSES;
